import * as api from "Api";
import * as actions from "Actions";
export const fetchAvailableSlide = () => {
  return (dispatch, getState) => {
    const { uen, id } = getState().auth.currentOrganization;
    const { paginationPage, pageSize, filterStatus } = getState().slideList;
    const {
      labels,
      indicators,
      status,
      isPublic,
      operator,
      newSlideIds
    } = getState().slideList.filter;
    const { backOffice } = getState().params;
    let data = {
      paginationPage,
      pageSize,
      labels,
      indicators,
      status,
      uen,
      id,
      backOffice,
      isPublic,
      operator,
      filterStatus,
      newSlideIds
    };
    dispatch(
      actions.fetchAvailableSlide(
        api.getAvailableSlide(data).then(res => {
          return res.data;
        })
      )
    );
  };
};

export const fetchIndicatorSuggestions = ({ searchWord, lng }) => {
  return (dispatch, getState) => {
    const { uen } = getState().auth.currentOrganization;
    return dispatch(
      actions.setIndicatorSuggestions(
        api.getIndicatorsSuggestions({ organizationUen: uen, searchWord, lng })
      )
    );
  };
};

export const deleteSlide = id => (dispatch, getState) => {
  return dispatch(
    actions.deleteSlide(
      api.deleteSlideApi({
        id: id
      })
    )
  );
};
export const updatePrivacySlide = (id, isEditable) => (dispatch, getState) => {
  return dispatch(
    actions.updatePrivacySlide(
      api.updateSlidePrivacyApi({
        id: id,
        isEditable: isEditable
      })
    )
  );
};
export const updateStateSlide = (id, uen) => (dispatch, getState) => {
  return dispatch(
    actions.updateStateSlide(
      api.updateSlideStateApi({
        id: id,
        uen: uen
      })
    )
  );
};
export const duplicateSlide = id => (dispatch, getState) => {
  const {
    auth: { currentOrganization },
    params: { backOffice }
  } = getState();
  return dispatch(
    actions.duplicateSlide(
      api.duplicateSlide({
        uen: currentOrganization.uen,
        id: id,
        status: backOffice ? "STANDARD" : "CREATED",
        isBackOffice: backOffice ? true : false
      })
    )
  );
};
export const setSlidePrivate = id => (dispatch, getState) => {
  return dispatch(
    actions.setSlidePrivate(
      api.setSlidePrivate({
        id: id
      })
    )
  );
};
export const useSharedSlide = (id, uen) => (dispatch, getState) => {
  return dispatch(
    actions.useSharedSlide(
      api.useSharedSlideApi({
        id: id,
        uen: uen
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/slideList.js